<ng-container>
	<dodo-base-header></dodo-base-header>
	<div class="container">
		<div class="payment-header">Thank you</div>
	</div>

	<div >
		<div class="container">
			
			<h3 id="for-desktop">
				Thanks for your payment.<br />
				Please let the sales representative know you're done so they can finalise your order.
			</h3>
			<h3 id="for-mobile">
				Thanks for your payment. Please let the sales representative know you're done so they can finalise your order.
			</h3>
		</div>
	</div>
	
</ng-container>
	